import script from "./StudentGradesDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentGradesDialog.vue?vue&type=script&setup=true&lang=js"

import "./StudentGradesDialog.vue?vue&type=style&index=0&id=585cb44d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-585cb44d"]])

export default __exports__